export default "<narwhalia-navbar></narwhalia-navbar>\r\n<router-outlet></router-outlet>\r\n";